import $ from 'jquery';
import twitterFetcher from 'twitter-fetcher';

export default class Footer {
  constructor({ el }) {
    this.$el = $(el);
    this._validate();
  }

  update($el) {
    this.$el = $el;
    this._validate();
  }

  _validate() {
    this.twitterId = $('.footer-tweet', this.$el).data('twitter-id');
    this.twitterRetweets = $('.footer-tweet', this.$el).data('twitter-retweets');

    if ($('.twitter-enabled', this.$el).length) {
      this.fetchTweets(this.twitterId, this.twitterRetweets);
    }
  }

  fetchTweets() {
    const config = {
      profile: { screenName: this.twitterId },
      maxTweets: 1,
      enableLinks: true,
      showUser: true,
      showTime: true,
      showRetweet: this.twitterRetweets,
      customCallback: (tweets) => this.renderTweets(tweets),
      showInteraction: false,
    };

    twitterFetcher.fetch(config);
  }

  renderTweets(tweets) {
    if (tweets.length) {
      $('.footer-tweet', this.$el).append(`<span class='tweet-wrap'>${tweets[0]}</span>`);
    } else {
      console.log('No tweets to display. Most probably cause is an incorrectly entered Widget ID.');
    }
  }
}
